import { TextKey, DataTestId } from '@mews-commander/enums';
import { Date, showSuccessAlert, showErrorAlert, lt, useGainsightService } from '@mews/framework';
import { useMutateMulticurrencyConfiguration } from '../hooks/useMutateMulticurrencyConfiguration';
import { FeatureToggle } from './FeatureToggle';

interface TerminalPaymentsFeatureToggleProps {
    isActive: boolean;
    isFetching: boolean;
    isFxMulticurrencyServiceEnabled: boolean;
    isMulticurrencyServiceEnabled: boolean;
    multicurrencyStartDate: Date | null;
}

export const TerminalPaymentsFeatureToggle = ({
    isActive,
    isFetching,
    isFxMulticurrencyServiceEnabled,
    isMulticurrencyServiceEnabled,
    multicurrencyStartDate,
}: TerminalPaymentsFeatureToggleProps) => {
    const gainSightService = useGainsightService();
    const { mutate, isPending, latestMutationStateVariables } = useMutateMulticurrencyConfiguration();

    const shouldDisplayOptimisticUpdate = isPending || isFetching;

    const handelChange = (newDccValue: boolean) => {
        mutate(
            {
                isDccMultiCurrencyServiceEnabled: newDccValue,
                isFxMultiCurrencyServiceEnabled: isFxMulticurrencyServiceEnabled,
            },
            {
                onSuccess: () => {
                    showSuccessAlert({
                        description: newDccValue
                            ? lt('MulticurrencySettingsConfigurationAlertSuccessTerminalEnabled')
                            : lt('MulticurrencySettingsConfigurationAlertSuccessTerminalDisabled'),
                    });
                    // Gainsight event only to be tracked for toggle set to false
                    if (newDccValue === false) {
                        gainSightService.trackEvent('MulticurrencyTerminalPaymentsDisabled');
                    }
                },
                onError: () => {
                    showErrorAlert({
                        description: newDccValue
                            ? lt('MulticurrencySettingsConfigurationAlertErrorMulticurrencyEnabled')
                            : lt('MulticurrencySettingsConfigurationAlertErrorMulticurrencyDisabled'),
                    });
                },
            }
        );
    };

    return (
        <FeatureToggle
            dataTestId={DataTestId.MulticurrencySettingsFeatureToggleTerminal}
            isActive={
                shouldDisplayOptimisticUpdate &&
                latestMutationStateVariables?.isDccMultiCurrencyServiceEnabled !== undefined
                    ? latestMutationStateVariables.isDccMultiCurrencyServiceEnabled
                    : isActive
            }
            isDisabled={isFetching || isPending}
            isMulticurrencyServiceEnabled={isMulticurrencyServiceEnabled}
            label={TextKey.MulticurrencySettingsFeatureHeadingTerminal}
            multicurrencyStartDate={multicurrencyStartDate}
            onChange={handelChange}
            shouldShowSpinner={isPending}
        />
    );
};
